// extracted by mini-css-extract-plugin
export var dismissOverlay = "_df-b";
export var interactivePassthrough = "_df-3";
export var modal = "_df-d";
export var modalBackdrop = "_df-c";
export var modalBody = "_df-j";
export var modalDescription = "_df-m";
export var modalEnter = "_df-e";
export var modalFooter = "_df-n";
export var modalHeaderText = "_df-h";
export var modalIconCircle = "_df-i";
export var modalIconHeader = "_df-g";
export var modalImage = "_df-f";
export var modalSectionLabel = "_df-k";
export var modalTitle = "_df-l";
export var pulse = "_df-1";
export var pulseBorder = "_df-2";
export var spotlight = "_df-0";
export var tooltip = "_df-4";
export var tooltipButtons = "_df-9";
export var tooltipDescription = "_df-6";
export var tooltipFooter = "_df-7";
export var tooltipInteractivePill = "_df-a";
export var tooltipStepIndicator = "_df-8";
export var tooltipTitle = "_df-5";